// jQueryプラグイン
import anime from 'animejs/lib/anime.es.js';
//トップページ　キービジュアルスライダー
import slick from 'slick-carousel';
export function careersFunc() {
  let careersTop = $('#careersTop').length;

  let resizecheck = $('#responsibleCheck').width();

  $(window).on('resize', function () {
    resizecheck = $('#responsibleCheck').width();
  });

  if(careersTop){
    let recruitFixed = $('#recruitFixed').length;

    const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms));

    $('.newsSlideArea').slick({
      loop: true,
      speed: 400,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      fade: false,
      infinite: true,
      prevArrow: '<img src="/images/common/slide_arrows_prev.svg" class="slide-arrow next-arrow">',
      nextArrow: '<img src="/images/common/slide_arrows_next.svg" class="slide-arrow prev-arrow">',
      responsive: [
        {
          breakpoint: 768, // 399px以下のサイズに適用
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    function workStyleSupportLoopImgSp(){
      if (resizecheck == '1'){
        $('#workStyleSupportLoopImgSp.slick-initialized').slick('unslick');
      } else{
        $('#workStyleSupportLoopImgSp').not(".slick-initialized").slick({
          autoplay: true,
          autoplaySpeed: 0,
          speed: 5000,
          cssEase: "linear",
          slidesToShow: 1,
          swipe: false,
          arrows: false,
          pauseOnFocus: false,
          pauseOnHover: false,
          variableWidth: false,
        });
      }

      $('.workStyleSupportLoopImgSp').each(function (i) {
        var $_t = $(this);
        let slideClass = $_t.addClass('slide' + i)

        if (resizecheck == '1'){
          $('.workStyleSupportLoopImgSp.slick-initialized').slick('unslick');
        } else{
          //スライダー部分
          slideClass.not(".slick-initialized").slick({
            autoplay: true,
            autoplaySpeed: 0,
            speed: 5000,
            cssEase: "linear",
            slidesToShow: 1,
            swipe: false,
            arrows: false,
            pauseOnFocus: false,
            pauseOnHover: false,
            variableWidth: false,
          });
        }
    
      });
    }

    function txtParaRight(elm) {
      let winScroll = $(window).scrollTop();
      var windowH = window.innerHeight;
      var elm = $(elm);
      elm.each(function () {
        var elemO = elm.offset().top;
        var elemH = elm.height();

        if(winScroll > elemO - windowH && winScroll < elemO + elemH){
          elm.css('transform', 'translateX(' + ((elemO - winScroll) / 14) + 'px)');
        }
      });
    }
    function txtParaLeft(elm) {
      let winScroll = $(window).scrollTop();
      var windowH = window.innerHeight;
      var elm = $(elm);
      elm.each(function () {
        var elemO = elm.offset().top;
        var elemH = elm.height();

        if(winScroll > elemO - windowH && winScroll < elemO + elemH){
          elm.css('transform', 'translateX(' + ((winScroll - elemO) / 14) + 'px)');
        }
      });
    }

    function careersCommonAnimeFunc() {
      $('.pageEntrance').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 200) {
          wait(0)
          .then(() => {
            if (!$(this).find('.imgBox').hasClass('isShow')) {
              $(this).find('.imgBox').addClass('isShow');
            }
            return wait(500)
          })
          .then(() => {
              if (!$(this).find('.pageEntranceTit').hasClass('isShow')) {
                $(this).find('.pageEntranceTit').addClass('isShow');
                $(this).find('.pageEntranceSubTit').addClass('isShow');
                $(this).find('.pageEntranceTxt').addClass('isShow');
                $(this).find('.btn01').addClass('isShow');
              }
              return wait(100)
          })
        }
      });
    }

    function careersRecruitFixedFunc() {
      if(recruitFixed){
        $('.recruitArea').each(function () {
          var position = $(this).offset().top;
          var scroll = $(window).scrollTop();
          var windowHeight = $(window).height();
    
          if (scroll > position - windowHeight) {
            $('#recruitFixed').addClass('hide');
          } else{
            $('#recruitFixed').removeClass('hide');
          }
        });
      }
    }

    function recruitAreaAnimeFunc() {
      $('.recruitArea').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 200) {
          wait(0)
          .then(() => {
            if (!$(this).hasClass('isShow')) {
              $(this).addClass('isShow');
              $(this).find('.imgBox').addClass('isShow');
            }
            return wait(500)
          })
          .then(() => {
              if (!$(this).find('.recruitAreaTit').hasClass('isShow')) {
                $(this).find('.recruitAreaTit').addClass('isShow');
                $(this).find('.btn04').addClass('isShow');
              }
              return wait(100)
          })
        }
      });
    }

    function peopleAboutAnimeFunc() {
      $('.peopleAboutCon').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 200) {
          wait(0)
          .then(() => {
            if (!$(this).hasClass('isShow')) {
              $(this).addClass('isShow');
              $(this).find('.imgBox').addClass('isShow');
            }
            return wait(500)
          })
          .then(() => {
              if (!$(this).find('.peopleAboutConTit').hasClass('isShow')) {
                $(this).find('.peopleAboutConTit').addClass('isShow');
                $(this).find('.peopleAboutConTxt').addClass('isShow');
              }
              return wait(500)
          })
        }
      });
    }

    function peopleInterviewAnimeFunc() {
      $('.interviewProfile').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 200) {
          wait(0)
          .then(() => {
            if (!$(this).hasClass('isShow')) {
              $(this).addClass('isShow');
              $(this).find('.img').addClass('isShow');
            }
            return wait(500)
          })
          .then(() => {
              if (!$(this).find('.interviewTit').hasClass('isShow')) {
                $(this).find('.interviewTit').addClass('isShow');
                $(this).find('.division').addClass('isShow');
                $(this).find('.name').addClass('isShow');
                $(this).find('.profile').addClass('isShow');
              }
              return wait(500)
          })
        }
      });
    }

    function peopleCrossTalkAnimeFunc() {
      $('.crossTalkProfile').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 200) {
          wait(0)
          .then(() => {
            if (!$(this).hasClass('isShow')) {
              $(this).addClass('isShow');
              $(this).find('.img').addClass('isShow');
            }
            return wait(500)
          })
          .then(() => {
              if (!$(this).find('.crossTalkTit').hasClass('isShow')) {
                $(this).find('.crossTalkTit').addClass('isShow');
              }
              return wait(500)
          })
        }
      });
    }

    function careerSystemAnimeFunc() {
      $('.careersBoxAnime').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 200) {
          wait(0)
          .then(() => {
            if (!$(this).find('.imgBox').hasClass('isShow')) {
              $(this).find('.imgBox').addClass('isShow');
            }
            return wait(500)
          })
          .then(() => {
              if (!$(this).find('.careersBoxTit').hasClass('isShow')) {
                $(this).find('.careersBoxTit').addClass('isShow');
                $(this).find('.careersBoxTxt').addClass('isShow');
              }
              return wait(500)
          })
        }
      });
    }

    workStyleSupportLoopImgSp();
    careersCommonAnimeFunc();
    careersRecruitFixedFunc();
    recruitAreaAnimeFunc();
    peopleCrossTalkAnimeFunc();
    peopleAboutAnimeFunc();
    peopleInterviewAnimeFunc();
    careerSystemAnimeFunc();
    txtParaRight('.peopleDecoTxt');
    txtParaRight('.careerDecoTxt');
    txtParaLeft('.workingDecoTxt');

    $(window).on('resize', function () {
      workStyleSupportLoopImgSp();
    });

    $(window).on('load scroll', function () {
      careersCommonAnimeFunc();
      careersRecruitFixedFunc();
      recruitAreaAnimeFunc();
      peopleCrossTalkAnimeFunc();
      peopleAboutAnimeFunc();
      peopleInterviewAnimeFunc();
      careerSystemAnimeFunc();
      txtParaRight('.peopleDecoTxt');
      txtParaRight('.careerDecoTxt');
      txtParaLeft('.workingDecoTxt');
    });
  }
}